export function getProductByStorefrontId(storefrontId, products = []) {
  return products.find(p => p.storefrontId === storefrontId)
}
